const projectsData = [
    {
    id: 'Datavizai',
    name: "Dataviz-AI",
    category: ["web app", "saas"],
    tagline: "Smart Data Analyser powered by AI Agents & Deep Learning",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/dataviz1.png",
      "https://portfolio-images-29.netlify.app/169/after/dataviz2.png",
      "https://portfolio-images-29.netlify.app/169/after/dataviz3.png",
      "https://portfolio-images-29.netlify.app/169/after/dataviz4.png"
        ],
    github: "https://github.com/sanjayattelli29",
    website: "https://dataviz-ai.netlify.app/",
    about: "Still in development—design updates coming. Feel free to email feedback!",
    techStack: ["Python", "MongoDB", "AWS-Lambda", "S3", "Next.JS", "Deep Learning", "AI Agents"],

  },
  {
    id: 'notes-galaxy',
    name: "NotesGalaxy",
    category: ["web app", "saas"],
    tagline: "All-in-one solution for note-taking, task management, and file storage",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/notes1.jpeg",
      "https://portfolio-images-29.netlify.app/169/after/notes2.jpeg",
      "https://portfolio-images-29.netlify.app/169/after/notes3.jpeg",
      "https://portfolio-images-29.netlify.app/169/after/notes4.png",
      "https://portfolio-images-29.netlify.app/169/after/notes5.png",
      "https://portfolio-images-29.netlify.app/169/after/notes6.png"

    ],
    github: "https://github.com/sanjayattelli29/Notes-Galaxy",
    website: "https://dought-flow-2.vercel.app/",
    about: "Login details to interact with project — Username: user1@gmail.com, Password: 01@user",
    techStack: ["Python", "Flask", "AWS", "TypeScript", "React.js", "JavaScript", "Supabase"]

  },
  {
    id: 'ecommerce',
    name: "Ecommerce Digital Store",
    category: ["web app", "saas"],
    tagline: "Premium digital products marketplace for content creators and professionals",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/ecom1.png",
      "https://portfolio-images-29.netlify.app/169/after/ecom2.png",
      "https://portfolio-images-29.netlify.app/169/after/ecom3.png",
      "https://portfolio-images-29.netlify.app/169/after/ecom4.png",
      "https://portfolio-images-29.netlify.app/169/after/ecom5.png"
    ],
    techStack: ["React.js", "TypeScript", "Node.js", "Tailwind CSS", "AWS Lambda", "Figma", "Framer Motion"],
    github: "https://github.com/yourusername/ecommerce-digital-store",
    website: "https://editwithsanjay.in",
    about: "Modern e-commerce platform with 20k+ community followers, offering seamless purchasing of high-quality digital products."
  },
  {
    id: 'fin-track-2.0',
    name: "Fin-Track 2.0 Design+Dev 💵🪙",
    category: ["web app", "saas", "ui-ux"],
    tagline: "Master Your Money with Clarity and Control",
    images: [
      "https://res.cloudinary.com/dws3beqwu/image/upload/v1746870071/fin1_xta8gb.png"
    ],
    techStack: ["React.js", "Node.js", "Tailwind CSS", "Figma", "Framer Motion"],
    github: "https://github.com/sanjayattelli29/Fin-Track-2.0",
    website: "http://fin-track-20.netlify.app/",
    about: "Login details to interact with project — Username: editwithsanjay, Password: 29@Sanjay",
  },
  
  {
    id: 'agri-assist-app',
    name: "Agri Assist",
    category: ["web app", "machine learning"],
    tagline: "Smart farming companion with ML-powered crop predictions and disease detection",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/agri1.png",
      "https://portfolio-images-29.netlify.app/169/after/agri2.png",
      "https://portfolio-images-29.netlify.app/169/after/agri3.png",
      "https://portfolio-images-29.netlify.app/169/after/agri4.png",
      "https://portfolio-images-29.netlify.app/169/after/agri5.png",
      "https://portfolio-images-29.netlify.app/169/after/agri8.png"
    ],
    techStack: ["Machine Learning", "Random Forest", "KNN", "TypeScript", "Node.js", "Supabase"],
    github: "https://github.com/sanjayattelli29/Agri-Assist-version2",
    website: "https://agri-assist-2.netlify.app/",
    about: "Research project utilizing advanced ML models for crop prediction, disease detection, and farming recommendations."
  },
  {
    id: 'content-flow',
    name: "Content-Flow",
    category: ["web app", "saas"],
    tagline: "Streamlined content workflow management solution",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/content-flow 1.png",
      "https://portfolio-images-29.netlify.app/169/after/content2.png",
      "https://portfolio-images-29.netlify.app/169/after/content3.png"
    ],
    techStack: ["React.js", "TypeScript", "Node.js", "Tailwind CSS", "Figma", "Framer Motion"],
    github: "https://github.com/sanjayattelli29/content-flow-20",
    website: "https://content-flow-20.netlify.app/",
    about: "Intuitive content workflow solution for efficient task planning, assignment, and tracking with analytics."
  },
  {
    id: 'web-insights',
    name: "Web-Insights",
    category: ["web app"],
    tagline: "Real-time website analytics and traffic monitoring platform",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/traffic 1.png",
      "https://portfolio-images-29.netlify.app/169/after/traffic2.jpeg"

    ],
    techStack: ["React.js", "TypeScript", "Node.js", "Tailwind CSS", "AWS Lambda", "Figma", "Framer Motion"],
    github: "https://traff.netlify.app/",
    website: "https://traff.netlify.app/",
    about: "Advanced analytics platform with IP-based, country-based, and device-based monitoring capabilities."
  },
  {
    id: 'air-quality',
    name: "Air Quality Monitoring",
    category: ["web app", "machine learning"],
    tagline: "Real-time air quality monitoring and prediction system",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/air1.png",
      "https://portfolio-images-29.netlify.app/169/after/air2.png",
      "https://portfolio-images-29.netlify.app/169/after/air3.png",
      "https://portfolio-images-29.netlify.app/169/after/air4.png",
 
    ],
    techStack: ["Machine Learning", "Deep Learning", "TypeScript", "AWS", "Supabase"],
    github: "https://github.com/sanjayattelli29/AQI-Analysis-Hub",
    website: "https://aqi-analysis-hub.netlify.app/",
    about: "Research project achieving 96% accuracy in AQI predictions using ML/DL models and Google AQI API integration."
  },
  {
    id: 'ai-saas-design',
    name: "Smart AI SaaS Website Design",
    category: ["ui-ux", "web-design"],
    tagline: "Perfect for any SaaS business looking to showcase AI-based solutions with style and efficiency!",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/ai-saas 1.jpeg",
    ],
    techStack: ["Figma", "Adobe XD", "User Research"],
    github: "https://www.behance.net/gallery/207115323/Smart-AI-SaaS-Website-Design-Kit-",
    website: "https://www.behance.net/gallery/207115323/Smart-AI-SaaS-Website-Design-Kit-",
    about: "A modern SaaS website design showcasing AI solutions with style and efficiency."
  },
  {
    id: 'power-your-ride',
    name: "Power Your Ride with Electric Mobility",
    category: ["web app"],
    tagline: "This E-bike UI design is modern, user-friendly, with bold visuals and clear calls-to-action.",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/power your ride 1.png",
    ],
    techStack: ["Figma", "Adobe XD", "UI/UX Design"],
    github: "https://www.behance.net/gallery/207119579/Power-Your-Ride-",
    website: "https://www.behance.net/gallery/207119579/Power-Your-Ride-",
    about: "Modern e-bike website with user-friendly interface and clear call-to-actions."
  },
  {
    "id": "aqi-analysis",
    name: "AQI Analysis Using ML and DL Models",
    "category": ["machine learning"],
    "tagline": "Real-time air quality analysis with 97% accuracy using LightGBM and other ML/DL models",
    "images": [
      "https://portfolio-images-29.netlify.app/169/after/aqiml1.png",
      "https://portfolio-images-29.netlify.app/169/after/aqiml2.png",
      "https://portfolio-images-29.netlify.app/169/after/aqiml3.png",
      "https://portfolio-images-29.netlify.app/169/after/aqiml4.png"
 

    ],
    "techStack": ["Machine Learning", "Deep Learning", "LightGBM", "Random Forest","Pandas", "NumPy", "Scikit-learn", "Plotly", "Matplotlib", "Seaborn",],
    "github": "https://air-stream-20-developwithsanjay.streamlit.app/",
    "website": "https://air-stream-20-developwithsanjay.streamlit.app/",
    "about": "Air Quality Index (AQI) analysis using Kaggle datasets and real-time data from Google API, achieving 97% accuracy with LightGBM. Deployed on Render and Netlify, integrated with Streamlit for live analytics."
  },
  {
    "id": "agri-assist-ml",
    "name": "Agri Assist",
    "category": ["machine learning"],
    "tagline": "Smart farming companion with ML-powered crop predictions and disease detection",
    "images": [
      "https://portfolio-images-29.netlify.app/169/after/agriml1.png",
      "https://portfolio-images-29.netlify.app/169/after/agriml2.png",
      "https://portfolio-images-29.netlify.app/169/after/agriml3.png",
      "https://portfolio-images-29.netlify.app/169/after/agriml4.png",
      "https://portfolio-images-29.netlify.app/169/after/agriml5.png"


    ],
    "techStack": ["Machine Learning", "Random Forest", "KNN","Pandas", "NumPy", "Scikit-learn", "Plotly", "Matplotlib", "Seaborn"],
    "github": "https://github.com/sanjayattelli29/AQI-ml-supabase",
    "website": "https://agri-analysis-app-models.streamlit.app/",
    "about": "ML-powered crop prediction system using real-time weather data and 8 input features, achieving 96% accuracy with Random Forest. Deployed on AWS, Netlify, and Streamlit for live updates and recommendations."
  },
  {
    "id": "brain-stroke-prediction",
    "name": "Brain Stroke Prediction Using ML Models",
    "category": ["machine learning"],
    "tagline": "Predicting brain strokes using advanced ML models with 12 metric analysis",
    "images": [
      "https://portfolio-images-29.netlify.app/169/after/brain1.png",
      "https://portfolio-images-29.netlify.app/169/after/brain2.png",
      "https://portfolio-images-29.netlify.app/169/after/brain3.png",
      "https://portfolio-images-29.netlify.app/169/after/brain4.png",
      "https://portfolio-images-29.netlify.app/169/after/brain5.png"
    ],
    "techStack": ["Machine Learning", "Logistic Regression", "Random Forest","Streamlit",],
    "github": "https://github.com/sanjayattelli29/Brain-stroke-prediction",
    "website": "https://app-brain-stroke-prediction.streamlit.app/",
    "about": "Predicting brain stroke risk using 11 features with models like Logistic Regression, Random Forest, and SVM. Advanced analysis with 12 metrics, deployed on Streamlit for easy accessibility and real-time predictions."
  },
  {
    "id": "uber-price-prediction",
    "name": "Hyderabad Ride Price Prediction",
    "category": ["machine learning"],
    "tagline": "Predicting Uber ride prices based on location, time, and conditions",
    "images": [
      "https://portfolio-images-29.netlify.app/169/after/uber1.png",
      "https://portfolio-images-29.netlify.app/169/after/uber2.png",
      "https://portfolio-images-29.netlify.app/169/after/uber3.png",
      "https://portfolio-images-29.netlify.app/169/after/uber4.png",
    ],
    "techStack": ["Machine Learning", "Streamlit", "Pandas", "NumPy", "Requests", "Scikit-learn", "Plotly", "Matplotlib", "Seaborn", "Pickle-mixin"],
    "github": "https://github.com/sanjayattelli29/Uber-Pricing-Recommendation",
    "website": "https://github.com/sanjayattelli29/Uber-Pricing-Recommendation",
    "about": "Predicts Uber ride prices for Hyderabad based on input conditions like location, time, weather, and traffic. Uses models like KNN and Random Forest, deployed on Render and Netlify with a Streamlit interface for dynamic interaction."
  },  
  {
    id: 'safari-parallax',
    name: "SAFARI 3D(Parallax) Scroll Magic",
    category: ["animations"],
    tagline: "The Safari Parallax Scroll Effect adds depth to the users 3D illusion on the Safari Car website.",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/safari 1.png"
    ],
    techStack: ["After Effects", "JavaScript", "Three.js"],
    github: "https://www.behance.net/gallery/207210077/SAFARI-3D(Parallax)-Scroll-Magic-",
    website: "https://www.behance.net/gallery/207210077/SAFARI-3D(Parallax)-Scroll-Magic-",
    about: "Interactive 3D parallax scrolling effect for an immersive car website experience."
  },
  {
    id: 'cursor-magic',
    name: "Cursor Vibrant Cursor Magic",
    category: ["animations"],
    tagline: "The cursor smoothly shifts between vibrant colors, creating an eye-catching user experience.",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/cursor color 1.png"
    ],
    techStack: ["JavaScript", "CSS", "Animation"],
    github: "https://www.behance.net/gallery/207210677/Cursor-Vibrant-Cursor-Magic-",
    website: "https://www.behance.net/gallery/207210677/Cursor-Vibrant-Cursor-Magic-",
    about: "Dynamic cursor animation with smooth color transitions for enhanced user interaction."
  },
  {
    id: 'parallax-swipe',
    name: "Dynamic Parallax Swipe",
    category: ["animations"],
    tagline: "Experience captivating parallax effects that create a sense of depth and motion.",
    images: [
      "https://s3-alpha.figma.com/hub/file/6566487085/dfd1dd64-7c76-487f-902e-72a960963e4f-cover.png"
    ],
    techStack: ["JavaScript", "GSAP", "CSS"],
    github: "https://www.behance.net/gallery/207212899/Dynamic-Parallax-Swipe-",
    website: "https://www.behance.net/gallery/207212899/Dynamic-Parallax-Swipe-",
    about: "Smooth parallax swipe animations for engaging user interactions."
  },
  {
    id: 'fruit-fusion-slider',
    name: "Fruit Fusion Slider",
    category: ["android app"],
    tagline: "Enjoy a fun and vibrant slider design featuring colorful fruits.",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/fruit 1.png"
    ],
    techStack: ["React Native", "Animation", "UI Design"],
    github: "https://www.behance.net/gallery/207212899/Dynamic-Parallax-Swipe-",
    website: "https://www.behance.net/gallery/207212899/Dynamic-Parallax-Swipe-",
    about: "Interactive mobile slider showcasing fruits with smooth animations and transitions."
  },
  {
    id: 'healthcare-excellence',
    name: "Healthcare Excellence",
    category: ["case-study", "ui-ux"],
    tagline: "This website design provides a clean, professional layout that emphasizes excellence.",
    images: [
      "https://portfolio-images-29.netlify.app/169/after/health care ui 1.png"
    ],
    techStack: ["Figma", "UI/UX Design", "User Research"],
    github: "https://www.figma.com/community/file/1413038071885654752/health-care-website-design",
    website: "https://www.figma.com/community/file/1413038071885654752/health-care-website-design",
    about: "A comprehensive healthcare website design focusing on user experience and accessibility."
  },
  {
    id: 'nike-app',
    name: "Nike App UI Design",
    category:  "ui-ux",
    tagline: "The app welcomes users with a smooth and engaging onboarding process, app right from the start.",
    images: [
      "https://mir-s3-cdn-cf.behance.net/project_modules/fs/34b64e207128873.66d8459957379.png"
    ],
    techStack: ["Figma", "UI/UX Design", "Prototyping"],
    github: "https://www.behance.net/gallery/207128873/Nike-App-UI-Design",
    website: "https://www.behance.net/gallery/207128873/Nike-App-UI-Design",
    about: "Modern and engaging Nike app UI design with smooth onboarding experience and intuitive navigation."
  },
  {
    id: 'snackfleet',
    name: "SNACKFLEET",
    category:  "ui-ux",
    tagline: "A 10-minute food delivery app sounds convenient, efficient, and incredibly fast.",
    images: [
      "https://s3-alpha.figma.com/hub/file/6158549733/ca02506c-acc3-4709-b0cd-5ad50c1fd20d-cover.png"
    ],
    techStack: ["Figma", "UI/UX Design", "Mobile App Design"],
    github: "https://www.behance.net/gallery/207129449/SNACKFLEET(10-minute-food-delivery-app)",
    website: "https://www.behance.net/gallery/207129449/SNACKFLEET(10-minute-food-delivery-app)",
    about: "Fast-paced food delivery app design focusing on quick service and user convenience."
  },
  {
    id: 'spatial-flow',
    name: "Spatial Flow UI",
    category:  "ui-ux",
    tagline: "Experience smooth and visually stunning transitions between UI elements, enhancing the overall user journey.",
    images: [
      "https://s3-alpha.figma.com/hub/file/6566363107/3a98bf09-5f80-465d-a9b5-7141d72f3621-cover.png"
    ],
    techStack: ["Figma", "Animation", "UI Design"],
    github: "https://www.behance.net/gallery/207212061/Spatial-Flow-UI-",
    website: "https://www.behance.net/gallery/207212061/Spatial-Flow-UI-",
    about: "Innovative UI design with fluid transitions and spatial interactions for enhanced user experience."
  },
  {
    id: 'netflix-case',
    name: "Netflix Landing Page UX Case Study",
    category: "caseStudy",
    tagline: "This case study explores the UX design improvements for Netflix's landing page, intuitive navigation.",
    images: [
      "https://s3-alpha.figma.com/hub/file/6567184284/a0c1b73e-cb1f-4759-ac53-c26baead9226-cover.png"
    ],
    techStack: ["UX Research", "UI Design", "User Testing"],
    github: "https://www.behance.net/gallery/207213825/-Netflix-Landing-Page-UX-Case-Study-",
    website: "https://www.behance.net/gallery/207213825/-Netflix-Landing-Page-UX-Case-Study-",
    about: "Comprehensive UX case study analyzing and improving Netflix's landing page design and user flow."
  },
  {
    id: 'bookmyshow-case',
    name: "BookMyShow Deck UX Case Study",
    category: "caseStudy",
    tagline: "This Behance project presents a streamlined redesign of the BookMyShow interface.",
    images: [
      "https://s3-figma-hubfile-images-production.figma.com/hub/file/carousel/img/e01cac4c301735006c080e6721c8f02357de3702/06945e89bee670347a546f346a1070960b7bcf86"
    ],
    techStack: ["UX Research", "UI Design", "Prototyping"],
    github: "https://www.behance.net/gallery/207213195/Showtime-Simplified-BookMyShow-Deck-",
    website: "https://www.behance.net/gallery/207213195/Showtime-Simplified-BookMyShow-Deck-",
    about: "Detailed case study on improving BookMyShow's user interface and booking experience."
  },
  {
    id: 'spotify-case',
    name: "Spotify Case Study",
    category: "caseStudy",
    tagline: "Unveiling the Case Study: Dive into our first captivating case study focused on Spotify.",
    images: [
      "https://miro.medium.com/v2/resize:fit:1400/1*VnWaQTFC6AdnbggQNLc37g.png"
    ],
    techStack: ["UX Research", "UI Design", "User Testing"],
    github: "https://www.behance.net/gallery/207214585/Spotify-Case-Study-",
    website: "https://www.behance.net/gallery/207214585/Spotify-Case-Study-",
    about: "In-depth analysis of Spotify's user experience and interface design patterns."
  },
  {
    id: 'travel-case',
    name: "Travel App UX Case Study",
    category: ["case-study",  "ui-ux"],
    tagline: "Discover how we designed an intuitive and engaging experience for globetrotters.",
    images: [
      "https://s3-alpha.figma.com/hub/file/6568072089/51c1d877-fd0b-40b0-ba81-123cb393af39-cover.png"
    ],
    techStack: ["UX Research", "UI Design", "Prototyping"],
    github: "https://www.behance.net/gallery/207214863/Explore-Go-Travel-App-UX-Case-Study-",
    website: "https://www.behance.net/gallery/207214863/Explore-Go-Travel-App-UX-Case-Study-",
    about: "Comprehensive case study on creating an intuitive travel app experience for modern travelers."
  }
];

  

export default projectsData;
